export default __webpack_public_path__ + "06f87297a840ca2bea2a8a72ad459557.png";